export default "__VITE_ASSET__BmtbXiWp__"